import { setupSettingsButton } from './settings_button';

export async function setupExtensions() {
    await setupSettingsButton();
}
